// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import {
   ExpansionHeaderRow,
   MarketplaceListingRow,
   AdditionalStorageRow,
   SponsorshipRow,
   PaidServiceRow,
   HistoricalDataImportRow,
   TestAccountRow,
} from '../rows/expansion'
import {
   QuoteAccordion,
   HorizontalRule,
   SpacerThick,
} from '../ui-helper-elements'

// JS Imports
// Asset Imports

export default function ExpansionSection() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['ExpansionSection']

   if (
      permissions.includes(state.user_role) ||
      state.productAdditionalStorageCount > 0 ||
      state.productHistoricalDataImport ||
      state.productMarketplaceListing ||
      state.productPaidServiceAmount > 0 ||
      state.productSponsorship
   ) {
      if (state.user_view == 'External') {
         return (
            <QuoteAccordion
               accordionName='Expansion'
               accordionBodyId='expansionAccordion'
               collapse={state.user_view == 'External' ? 'true' : 'false'}
            >
               <ExpansionHeaderRow />
               <AdditionalStorageRow />
               <MarketplaceListingRow />
               <HistoricalDataImportRow />
               <SponsorshipRow />
               <PaidServiceRow />
               <TestAccountRow />
            </QuoteAccordion>
         )
      } else {
         return (
            <div>
               <HorizontalRule />
               <ExpansionHeaderRow />
               <AdditionalStorageRow />
               <HistoricalDataImportRow />
               <MarketplaceListingRow />
               <SponsorshipRow />
               <PaidServiceRow />
               <TestAccountRow />
            </div>
         )
      }
   }

   return null
}
